// The posts module. You can add any additional things you want.
export default {
    namespaced: true,
  
    actions: {
      test () {
        // console.log(this)
      }
    }
  } 